import { HStack, Text, VStack } from '@genial/components';
import { BoxRadius, Spacing } from '@genial/design-tokens';
import React from 'react';

import { TableContent } from '../../../../../../../../../components/TableContent';
import { LateralBar } from '../../../../../../../../BatchTicket/components/DynamicAsset/components/Asset/components/LateralBar';
import {
  DetailsSkeleton,
  TextSkeleton,
} from '../../../../../../../../BatchTicket/components/DynamicAsset/components/AssetsLoading';
import { useGlobalProductContext } from '../../../../../contexts';

export const ListLoadingItemTablet: React.FC = () => {
  const { product } = useGlobalProductContext();

  const topInfos = [
    { label: 'Tipo', value: <TextSkeleton w="60%" />, maxW: '24%' },
    { label: 'Mês', value: <TextSkeleton w="60%" />, maxW: '24%' },
    { label: 'Ano', value: <TextSkeleton w="60%" />, maxW: '24%' },
    { label: '12 Meses', value: <TextSkeleton w="60%" />, maxW: '24%' },
  ];

  const bottomInfos = [
    { label: 'Aplic. Min', value: <TextSkeleton w="60%" />, maxW: '24%' },
    { label: 'Data início', value: <TextSkeleton w="60%" />, maxW: '24%' },
    { label: 'Data de referência', value: <TextSkeleton w="60%" />, maxW: '24%' },
  ];

  return (
    <TableContent direction="row" space={0} p={0} px={Spacing['inline.xxxs']}>
      <LateralBar
        backgroundColor={product.color}
        borderTopLeftRadius={BoxRadius.sm}
        borderBottomLeftRadius={BoxRadius.sm}
      />
      <VStack padding={Spacing['inset.sm']} space={Spacing['stack.xxxs']} w="full">
        <HStack justifyContent="space-between" alignItems="center">
          <TextSkeleton w="60%" />
          <DetailsSkeleton />
        </HStack>
        <HStack alignItems="flex-start">
          {topInfos.map(({ label, value, maxW }) => (
            <VStack maxWidth={maxW} width={maxW} space={Spacing['stack.quarck']} key={label}>
              <Text color="neutral.black" variant="semibold">
                {label}
              </Text>
              {value}
            </VStack>
          ))}
        </HStack>
        <HStack>
          {bottomInfos.map(({ label, value, maxW }) => (
            <VStack maxWidth={maxW} width={maxW} space={Spacing['stack.quarck']} key={label}>
              <Text color="neutral.black" variant="semibold">
                {label}
              </Text>
              {value}
            </VStack>
          ))}
        </HStack>
      </VStack>
    </TableContent>
  );
};
